import React, { useContext, useEffect } from "react";
import { Box } from "@mui/material";
import FormType, { FieldConfigs } from "../../../../../shared/components/FormType";
import { AuthenticationContext } from "../../../../../provider/AuthenticationProvider";
import { ROLE, STORAGE } from "../../../../../data/enums";
import { Customer } from "../../../../../data/entities";
import { api } from "../../../../../shared/hooks/api";

interface ExportProductFormProps {
    formData: any;
    onChange: (data: any) => void;
    lockAddress?: boolean;
}

export const ExportProductForm = ({ formData, onChange, lockAddress = false }: ExportProductFormProps) => {
    const [{ data: customers }] = api.get<Customer[]>("/customers/", { page: 1, page_size: 1000 });
    const {
        user: { role },
    } = useContext(AuthenticationContext);

    useEffect(() => {
        if (!formData.export_date) {
            const today = new Date();
            const vnTime = new Date(today.getTime() + (7 * 60 * 60 * 1000)); // UTC+7
            const vnDate = vnTime.toISOString().split("T")[0];
            onChange({
                ...formData,
                export_date: vnDate,
            });
        }
    }, []);
    console.log("formData", formData);



    useEffect(() => {
        const updates: any = {};
        if (!formData.storage) {
            updates.storage = STORAGE.FIRST;
        }
        if (!formData.reason) {
            updates.reason = "Xuất bán";
        }
        if (formData.customer && typeof formData.customer === "object") {
            const hasText = (formData.customer as any).text;
            const customerName = (formData.customer as any).name;
            if (!hasText && customerName) {
                updates.customer = {
                    ...(formData.customer as any),
                    text: customerName,
                    value: customerName,
                };
            }
            if (!lockAddress && !formData.address) {
                updates.address = (formData.customer as any).address || "";
            }
        }

        if (Object.keys(updates).length > 0) {
            onChange({
                ...formData,
                ...updates,
            });
        }
    }, [formData, lockAddress, onChange]);


    const handleCustomerSelect = (customer: any) => {
        onChange({
            ...formData,
            customer: customer || null,
            address: lockAddress ? formData.address : customer?.address || "",
        });
    };

    const fields: FieldConfigs[] = [
        {
            label: "Kho xuất",
            type: "dropdown",
            key: "storage",
            options: [
                { text: "Kho 1", value: "Kho 1" },
                { text: "Kho 2", value: "Kho 2" },
            ],
            required: true,
        },
        {
            label: "Khách hàng",
            key: "customer",
            type: "autocomplete",
            required: true,
            options: customers?.results?.map((customer: Customer) => ({
                ...customer,
                text: customer.name,
                value: customer.name,
            })),
            noDataText: "Không tìm thấy khách hàng",
            onChange: handleCustomerSelect,
        },
        {
            label: "Người nhận",
            type: "text",
            key: "receiver_name",
            required: false,
        },
        {
            label: "Địa chỉ",
            type: "text",
            key: "address",
            required: !lockAddress,
            disabled: lockAddress,
        },
        {
            label: "Lý do xuất",
            type: "dropdown",
            key: "reason",
            options: [
                { text: "Xuất bán", value: "Xuất bán" },
                { text: "Xuất khác", value: "Xuất khác" },
            ],
            required: true,
        },
        {
            label: "Ngày xuất kho",
            type: "calendar",
            key: "export_date",
            required: true,
        },
        {
            label: "Ghi chú",
            type: "text",
            key: "note",
            required: false,
        },
    ];

    const getFields = () => {
        const isStorageKeeper = [ROLE.FIRST_STORAGE_KEEPER, ROLE.SECOND_STORAGE_KEEPER].includes(role);
        if (isStorageKeeper) {
            return fields.filter((field: any) => field.label !== "Kho xuất");
        }

        return fields;
    };

    return (
        <Box sx={{ width: "100%" }}>
            <FormType
                title="Thông tin xuất kho"
                fields={getFields()}
                validated={false}
                requireData={formData}
                mergeFormData={onChange}
            />
        </Box>
    );
};
